/**
 * True when this window is the OAuth popup opened by the checkout page.
 *
 * Only a same-origin opener qualifies: a tab opened by an external site (e.g.
 * the marketing landing) also has window.opener, but reading a cross-origin
 * opener's location throws — treat that as "not our popup" and let the normal
 * login flow run.
 *
 * The popup must not consume the handoff code itself: the code is single-use
 * and the session belongs to the opener, so it is forwarded there instead.
 */
export default (): boolean => {
	try {
		return !!window.opener && window.opener.location.origin === window.location.origin;
	} catch {
		return false;
	}
};
